import styled from '@emotion/styled'
import { BreakPoint } from 'src/components/shared/CssValues'

type Props = {
  inlineIfMobile?: boolean
}

export const NoLineBreak = styled.div<Props>`
  display: inline-block;
  @media screen and (max-width: ${BreakPoint.MOBILE}) {
    display: ${({ inlineIfMobile }) =>
      inlineIfMobile ? 'inline' : 'inline-block'};
  }
`
